// Which charge a dialog is about: the engagement, the client, and the charge's own
// month (a retainer period) or date and amount. Shared by the correction and the cancel
// dialogs so the two name the same charge the same way.
import he from '../i18n/he';
import Money from './Money';
import DateText from './DateText';

const t = he.collections.board;

export default function ChargeHeader({ card, row }) {
  return (
    <p>
      <strong>{card.title}</strong>
      {card.clientName && <span className="muted"> · {card.clientName}</span>}
      {row.periodMonth
        ? <>{' · '}{t.forMonth} <DateText value={row.periodMonth} /></>
        : row.issueDate && <>{' · '}<DateText value={row.issueDate} /></>}
      {' · '}<Money value={row.amount} />
    </p>
  );
}
